import { render } from "./Contact.vue?vue&type=template&id=70c96767"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=70c96767&lang=css"
script.render = render

export default script